
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`La première vague`}</h2>
    <p>{`Lors de la première vague, de fin février à début juin 2020, il y avait des grappes d'infections principalement dans les communes proches de la frontière  sud  du pays et dans les cantons de Genève, des Grisons, du Tessin, de Vaud et du Valais. On observe par ailleurs nettement la vague qui avait frappé `}<a parentName="p" {...{
        "href": "https://www.24heures.ch/lematindimanche/accueil/weekend-fete-infecte-verbier/story/12110784"
      }}>{`Verbier`}</a>{`. En Suisse alémanique, on ne trouve en revanche que des cas isolés. `}</p>
    <p>{`Dans de petites municipalités, il faut relativiser les chiffres car un faible nombre de cas suffit à faire exploser l'incidence. Cependant, le nombre de cas de la première vague est certainement sous-estimé, car relativement peu de tests de dépistage ont été réalisés. Selon les chiffres officiels de l'OFSP, la première vague a causé 30'000 cas de Covid-19 et 2000 décès.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;